import styled from 'styled-components';
import { Checkbox as AntCheckbox } from 'components/atoms/checkbox';
import { DullCaption } from '../../../component';

export const Caption = styled(DullCaption)`
  font-size: var(--font-size-base) !important;
`;

// TODO: checkbox in atom has top 0 which affects design in here
export const Checkbox = styled(AntCheckbox)`
  height: inherit;
`;
